import { KMutableProperty11e8g1gb0ecb9j as KMutableProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance } from '../../models/data.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../reactive/Action.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  Link$_get_secondaryAction_$ref_3ak2cs31jrfzz00hclc as Link$_get_secondaryAction_$ref_3ak2cs,
  Link$_set_secondaryAction_$ref_a066jk1f1nlfkc25u6x as Link$_set_secondaryAction_$ref_a066jk,
} from './Link.commonHtml.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function set_onNavigateAction(_this__u8e3s4, _set____db54di) {
  _init_properties_Link_kt__dm1ox2();
  var tmp0 = onNavigateAction$delegate;
  var tmp = KMutableProperty1();
  var tmp_0 = _get_onNavigateAction_$ref_idjuto();
  // Inline function 'kotlin.setValue' call
  getPropertyCallableRef('onNavigateAction', 1, tmp, tmp_0, _set_onNavigateAction_$ref_4fh6tc());
  tmp0.set(_this__u8e3s4, _set____db54di);
  return Unit_instance;
}
function get_onNavigateAction(_this__u8e3s4) {
  _init_properties_Link_kt__dm1ox2();
  var tmp0 = onNavigateAction$delegate;
  var tmp = KMutableProperty1();
  var tmp_0 = _get_onNavigateAction_$ref_idjuto();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('onNavigateAction', 1, tmp, tmp_0, _set_onNavigateAction_$ref_4fh6tc());
  return tmp0.get(_this__u8e3s4);
}
var onNavigateAction$delegate;
function onNavigate(_this__u8e3s4, label, icon, frequencyCap, action) {
  label = label === VOID ? 'onNavigate' : label;
  icon = icon === VOID ? Companion_getInstance().send_1 : icon;
  var tmp;
  if (frequencyCap === VOID) {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance_0();
    tmp = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
  } else {
    tmp = frequencyCap;
  }
  frequencyCap = tmp;
  _init_properties_Link_kt__dm1ox2();
  set_onNavigateAction(_this__u8e3s4, Action(label, icon, VOID, VOID, frequencyCap, VOID, onNavigate$slambda(action)));
}
function _get_onNavigateAction_$ref_idjuto() {
  return constructCallableReference((p0) => get_onNavigateAction(p0), 1, 0, 119);
}
function _set_onNavigateAction_$ref_4fh6tc() {
  return constructCallableReference((p0, p1) => {
    set_onNavigateAction(p0, p1);
    return Unit_instance;
  }, 2, 0, 120);
}
function onNavigate$slambda($action) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    yield* $($action($completion), $completion);
    return Unit_instance;
  }), 1);
}
var properties_initialized_Link_kt_5x6v44;
function _init_properties_Link_kt__dm1ox2() {
  if (!properties_initialized_Link_kt_5x6v44) {
    properties_initialized_Link_kt_5x6v44 = true;
    var tmp = KMutableProperty1();
    var tmp_0 = Link$_get_secondaryAction_$ref_3ak2cs();
    onNavigateAction$delegate = getPropertyCallableRef('secondaryAction', 1, tmp, tmp_0, Link$_set_secondaryAction_$ref_a066jk());
  }
}
//region block: exports
export {
  get_onNavigateAction as get_onNavigateAction3fwn8i6kv096u,
  onNavigate as onNavigate2wu3qzsseblgb,
};
//endregion

//# sourceMappingURL=Link.mjs.map
